module.exports = "span h5 a:hover, span h4 a:hover, li span.profile-link a:hover {\n    color: #9e9e9e;\n}\n\n.follow-status {\n    margin-left: 5%;\n}\n\n.detailed-follow-btn {\n    background-color: #4eabec;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/content/detailed/profile/profile.component.css
// module id = ./src/app/components/dashboard/content/detailed/profile/profile.component.css
// module chunks = main